import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionHeldYourBackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionHeldYourBack.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionHeldYourBack.button1'),
          value: 'too_many_options',
        },
        {
          text: t('pages.onboarding.questionHeldYourBack.button2'),
          value: 'gave_up',
        },
        {
          text: t('pages.onboarding.questionHeldYourBack.button3'),
          value: 'didnt_know',
        },
        {
          text: t('pages.onboarding.questionHeldYourBack.button4'),
          value: 'couldnt_stay_consistent',
        },
        {
          text: t('pages.onboarding.questionHeldYourBack.button5'),
          value: 'didnt_track',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
